import { useCallback, useEffect, useState } from 'react'
import { infoApi, TvlResponse } from 'restApi'
import { FetchStatus } from 'state/types'

export const useExchangeInfo = () => {
  const [fetchStatus, setFetchStatus] = useState(FetchStatus.NOT_FETCHED)
  const [exchangeInfo, setExchangeInfo] = useState<TvlResponse>({
    tvlInUsd: '0',
    tvlInUsdByChain: {},
    maxSupply: '0',
    totalSupply: '0',
    circulatingSupply: '0',
    totalBurned: '0',
    marketCap: '0',
  })

  const fetchExchangeInfo = useCallback(async () => {
    if (fetchStatus === FetchStatus.FETCHING) return

    try {
      setFetchStatus(FetchStatus.FETCHING)
      const response = await infoApi.getInfo()
      setExchangeInfo(response)
      setFetchStatus(FetchStatus.FETCHED)
    } catch (error) {
      setFetchStatus(FetchStatus.FAILED)
      console.error('Failed to fetch exchange info', error)
    }
  }, [fetchStatus])

  useEffect(() => {
    if (fetchStatus === FetchStatus.NOT_FETCHED) {
      fetchExchangeInfo()
    }
    // The value is cached for 5 minutes on the backend
    const timerId = setInterval(fetchExchangeInfo, 300000)
    return () => clearInterval(timerId)
  }, [fetchExchangeInfo, fetchStatus])

  return { exchangeInfo, fetchStatus, fetchExchangeInfo }
}
